<template>
  <div>
    <v-form v-model="mainFormValid">
      <v-row>
        <v-col>
          <v-text-field
            v-model="internalValue.name"
            :label="$t('multiproject.fields.version.name')"
            :rules="$options.rules.name"
            @input="change"
          />
        </v-col>
        <v-col cols="auto">
          <ag-language-field
            v-model="internalValue.lang"
            :label="$t('general.language')"
            @change="change"
          />
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            v-model="internalValue.defaultVersion"
            :disabled="!create && disabledDefaultOptions"
            :label="$t('multiproject.fields.version.default')"
            @change="change"
          />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="6">
          <ag-card-container
            :title="$t('multiproject.title.projectNames')"
            fluid
          >
            <v-text-field
              v-for="i in 10"
              :key="`projectName-${i}`"
              v-model="internalValue.projectList[i - 1]"
              :label="$t('multiproject.fields.version.projectName', {index: i})"
              :rules="$options.rules.name"
              outlined
              dense
              @input="change"
            />
          </ag-card-container>
        </v-col>
        <v-col cols="6">
          <ag-card-container
            :title="$t('multiproject.title.ressourceNames')"
            fluid
          >
            <v-text-field
              v-model="internalValue.blueName"
              :label="$t('multiproject.fields.version.blue')"
              :rules="$options.rules.name"
              outlined
              dense
              @input="change"
            />
            <v-text-field
              v-model="internalValue.redName"
              :label="$t('multiproject.fields.version.red')"
              :rules="$options.rules.name"
              outlined
              dense
              @input="change"
            />
            <v-text-field
              v-model="internalValue.yellowName"
              :label="$t('multiproject.fields.version.yellow')"
              :rules="$options.rules.name"
              outlined
              dense
              @input="change"
            />
            <v-text-field
              v-model="internalValue.greenName"
              :label="$t('multiproject.fields.version.green')"
              :rules="$options.rules.name"
              outlined
              dense
              @input="change"
            />
          </ag-card-container>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import Helpers from 'src/utils/helpers'
import FormRules from 'src/utils/form-rules'
import AgCardContainer from 'src/components/common/AgCardContainer'
import AgLanguageField from 'src/components/common/AgLanguageField'

export default {
  name: 'VersionForm',
  components: {
    AgCardContainer,
    AgLanguageField,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        name: '',
        lang: '',
        defaultVersion: false,
        projectList: [
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        blueName: '',
        redName: '',
        yellowName: '',
        greenName: '',
      }),
    },
    create: {
      type: Boolean,
      default: false,
    },
    disabledDefaultOptions: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    internalValue: null,
    mainFormValid: false,
  }),
  computed: {
    isValidVersion () {
      return this.mainFormValid
        && this.internalValue.projectList.length === 10
    },
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.internalValue = Helpers.clone(value)
        this.$emit('validate', this.isValidVersion)
      },
    },
    isValidVersion: {
      immediate: true,
      handler () {
        this.$emit('validate', this.isValidVersion)
      },
    },
  },
  methods: {
    change () {
      this.$emit('input', this.internalValue)
      this.$emit('validate', this.isValidVersion)
    },
  },
  rules: {
    name: [
      FormRules.required('error.form.required'),
    ],
  },
}
</script>
